<div class="alertDetailsHistoric">
  <mat-card>
    <h3>{{ "alerts.historic" | translate }}</h3>
    <mat-card style="padding: 0px !important" [ngClass]="{ hide: !alert.actionsHistory || alert.actionsHistory?.length === 0 }">
      <table mat-table matSort matSortDirection="desc" matSortActive="date" [dataSource]="dataSource">
        <!-- date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.date" | translate }}
            <app-item-filter
              fieldName="{{ 'table.date' | translate }}"
              propertyName="actionDate"
              [dataType]="dataTypeDate"
              [defaultValue]="activeFilters | filterFor : 'actionDate'"
              (applyFilter)="applyFilter($event)"
            >
            </app-item-filter>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.actionDate | safeDate : "short" }}
          </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>
            {{ "table.action" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ getTranslations(element.action) }}
          </td>
        </ng-container>

        <!-- Author Column -->
        <ng-container matColumnDef="author">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.author" | translate }}
            <app-item-filter
              fieldName="{{ 'model.patient.name' | translate }}"
              propertyName="actionAuthor.display"
              [dataType]="dataTypeText"
              [defaultValue]="activeFilters | filterFor : 'actionAuthor.display'"
              (applyFilter)="applyFilter($event)"
            >
            </app-item-filter>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.actionAuthor.display }}
          </td>
        </ng-container>

        <!-- Comment Column -->
        <ng-container matColumnDef="comment">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "table.comment" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ getComment(element) || "-" }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator class="borderBox" #paginator [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 15]" [hidePageSize]="false">
      </mat-paginator>
    </mat-card>
    <p class="text-center" *ngIf="!alert.actionsHistory || alert.actionsHistory?.length === 0">
      {{ "widget.noData" | translate }}
    </p>
  </mat-card>
</div>
